import { api } from '../api';

export const locationService = {
  states: () => api.get('/states'),
  cities: (id: string) => api.get(`/cities/state/${id}`),
};